<template>
    <div class="container-fluid">
        <div>
            <h3>Usuários</h3>

        </div>
        <form class="row search">
            <div class="form-group col-md-12">
                <input v-on:keyup="filterUsers" class="form-control" id="search" v-model="search" ref="search" placeholder="Busca"/>
            </div>
        </form>
        <router-link to="/users/create" class="nav-link btn-create">
            <button class="btn btn-primary">
                Adicionar Usuário
            </button>
        </router-link>
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active" id="active-tab" data-bs-toggle="pill" data-bs-target="#active" type="button" role="tab" aria-controls="active" aria-selected="true">Ativos</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="disabled-tab" data-bs-toggle="pill" data-bs-target="#disabled" type="button" role="tab" aria-controls="disabled" aria-selected="false">Desativados</button>
            </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
                <table class="table table-striped users-table">
                    <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Login</th>
                        <th>Nivel de acesso</th>
                        <th width="110px">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in users" :key="user.id">
                        <td>{{ user.name }}</td>
                        <td>{{ user.login }}</td>
                        <td>{{ user.readable_role }}</td>
                        <td>
                            <router-link :to="{ path: '/users/edit/'+ user.id}" class="nav-link btn-create">
                                <button class="btn btn-primary">
                                    <i class="fas fa-edit"></i>
                                </button>
                            </router-link>
                            <button class="btn btn-danger" v-on:click="destroy(user.id)"><i class="far fa-trash-alt"></i></button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="tab-pane fade" id="disabled" role="tabpanel" aria-labelledby="disabled-tab">
                <table class="table table-striped users-table">
                    <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Login</th>
                        <th>Nivel de acesso</th>
                        <th width="110px">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in deletedUsers" :key="user.id">
                        <td>{{ user.name }}</td>
                        <td>{{ user.login }}</td>
                        <td>{{ user.readable_role }}</td>
                        <td>
                            <router-link :to="{ path: '/users/edit/'+ user.id}" class="nav-link btn-create">
                                <button class="btn btn-primary">
                                    <i class="fas fa-edit"></i>
                                </button>
                            </router-link>
                            <button class="btn btn-success" v-on:click="activate(user.id)"><i class="fas fa-check"></i></button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'Users',
        data () {
            return {
                users: {},
                search: '',
                deletedUsers: {},
            }
        },
        mounted (){
            this.index()
            this.deleted()
        },
        methods: {
            index () {
                axios
                    .get('/api/users?search=' + this.search)
                    .then((response) => {
                        this.users = response.data.data
                    })
            },
            destroy (id) {
                this.$confirm(
                    {
                        message: `Tem certeza que deseja excluir?`,
                        button: {
                            no: 'Não',
                            yes: 'Sim'
                        },
                        callback: confirm => {
                            if (confirm) {
                                axios.delete('/api/users/' + id)
                                    .then(() => {
                                        this.filterUsers()
                                    })
                            }
                        }
                    }
                )
            },
            filterUsers () {
                this.index()
                this.deleted()
            },
            deleted () {
                axios
                    .get('/api/users/deleted?search=' + this.search)
                    .then((response) => {
                        this.deletedUsers = response.data
                    })
            },
            activate (id) {
                this.$confirm(
                    {
                        message: `Tem certeza que deseja reativar?`,
                        button: {
                            no: 'Não',
                            yes: 'Sim'
                        },
                        callback: confirm => {
                            if (confirm) {
                                axios.put('/api/users/activate/' + id)
                                    .then(() => {
                                        this.filterUsers()
                                    })
                            }
                        }
                    }
                )
            }
        }
    }
</script>

<style scoped lang="sass">
    .search
        margin-top: 15px
        border-top: 1px solid #3c3c3c
        padding: 15px 0

    .btn-create
        float: right

    .users-table
        td
            a
                padding: 0
</style>
